/* ============================================================
   BaiRees Global Advisory — Navbar.css
   Dark navy · Gold accent · Smooth dropdown · Fully responsive
   ============================================================ */

/* ── Design tokens ───────────────────────────────────────── */
:root {
  --br-navy:         #010D1D;
  /* --br-navy:         #F7F6F2; */

  --br-navy-mid:     #010D1D;
  --br-navy-light:   #010D1D;
  --br-gold:         #c8963e;
  --br-gold-hover:   #daa85a;
  --br-white:        #F7F6F2;
  /* --br-white:        #010D1D; */

  /* --br-text-primary: rgba(255, 255, 255, 0.92); */
  --br-text-primary: #F7F6F2;
    /* --br-text-primary: #010D1D; */

  /* --br-text-muted:   rgba(255, 255, 255, 0.55); */
    /* --br-text-muted: #010D1D; */

  --br-text-muted: #F7F6F2;
  --br-border:       rgba(255, 255, 255, 0.08);
  --br-shadow-sm:    0 4px 16px rgba(0, 0, 0, 0.25);
  --br-shadow-lg:    0 12px 40px rgba(0, 0, 0, 0.45);
  --br-radius:       6px;
  --br-radius-lg:    10px;
  --br-nav-h:        78px;
  --br-ease:         cubic-bezier(0.4, 0, 0.2, 1);

  /* --font-display: 'Playfair Display', Georgia, serif; */
  /* --font-ui:      'DM Sans', 'Helvetica Neue', Arial, sans-serif; */
}

/* ── Reset ───────────────────────────────────────────────── */
.br-nav *,
.br-nav *::before,
.br-nav *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ── Root ────────────────────────────────────────────────── */
.br-nav {
  position: fixed;
  inset: 0 0 auto 0;
  height: var(--br-nav-h);
  z-index: 1000;
  background-color: var(--br-navy);
  border-bottom: 1px solid var(--br-border);
  font-family: var(--font-ui);
  transition: box-shadow 0.3s var(--br-ease),
              background-color 0.3s var(--br-ease);
}

.br-nav--scrolled {
  background-color: #010D1D;
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  box-shadow: var(--br-shadow-lg);
}

/* ── Inner layout ────────────────────────────────────────── */
.br-nav__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  max-width: 1440px;
  height: 100%;
  margin: 0 auto;
  padding: 0 2.5rem;
}

/* ── Logo ────────────────────────────────────────────────── */
.br-nav__logo {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  text-decoration: none;
  flex-shrink: 0;
  outline-offset: 4px;
}

.br-nav__logo-mark {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.br-nav__logo-img{
  width: 65px;
  /* border-radius: 50%; */
  /* border: 1px solid ; */
}
.br-nav__logo-img-text{
  height: 14px;
  /* border-radius: 50%; */
  /* border: 1px solid ; */
}
.br-nav__logo-img-sub{
    padding-top: 2px;

  height: 12px;
  /* border-radius: 50%; */
  /* border: 1px solid ; */
} 

.br-nav__logo-text {
  display: flex;
  flex-direction: column;
  line-height: 1;
  gap: 3px;
}

.br-nav__logo-name {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 700;
  /* letter-spacing: 0.02em; */
    letter-spacing: 0.16em;

    color: #F6C974;

}

.br-nav__logo-sub {
  font-size: 0.6rem;
  font-weight: 500;
  letter-spacing: 0.16em;
  text-transform: uppercase;
    color: var(--br-white);
    padding-top: 2px;
    padding-left: 1px;

}

/* ── Desktop nav links ───────────────────────────────────── */
.br-nav__links {
  display: flex;
  align-items: center;
  gap: 0;
  list-style: none;
  flex: 1;
  justify-content: center;
}

.br-nav__item {
  position: relative;
}

.br-nav__link {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  padding: 0.42rem 0.72rem;
  font-size: 0.875rem;
  font-weight: 500;
  font-family: var(--font-ui);
  color: var(--br-text-muted);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: var(--br-radius);
  white-space: nowrap;
  letter-spacing: 0.01em;
  transition: color 0.2s var(--br-ease),
              background-color 0.2s var(--br-ease);
  outline-offset: 3px;
}

.br-nav__link:hover {
  color: var(--br-text-primary);
  background-color: rgba(255, 255, 255, 0.06);
}

.br-nav__item--active .br-nav__link {
  color: var(--br-gold);
  background-color: rgba(200, 150, 62, 0.08);
}

/* gold underline for active item */
.br-nav__item--active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0.72rem;
  right: 0.72rem;
  height: 2px;
  background: var(--br-gold);
  border-radius: 2px 2px 0 0;
}

/* Chevron */
.br-nav__chevron {
  flex-shrink: 0;
  opacity: 0.5;
  transition: transform 0.22s var(--br-ease), opacity 0.22s var(--br-ease);
}

.br-nav__chevron--open {
  transform: rotate(180deg);
  opacity: 1;
}

/* ── Dropdown panel ──────────────────────────────────────── */
.br-nav__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%) translateY(6px);
  min-width: 230px;
  background: var(--br-navy-light);
  border: 1px solid var(--br-border);
  border-radius: var(--br-radius-lg);
  box-shadow: var(--br-shadow-lg);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s var(--br-ease),
              transform 0.2s var(--br-ease);
  z-index: 1100;
  overflow: hidden;
}

/* keep within viewport for rightmost items */
.br-nav__item:nth-last-child(-n+2) .br-nav__dropdown {
  left: auto;
  right: 0;
  transform: translateY(6px);
}

.br-nav__item:nth-last-child(-n+2) .br-nav__dropdown--visible {
  transform: translateY(0);
}

.br-nav__dropdown--visible {
  opacity: 1;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}

/* caret tip */
.br-nav__dropdown::before {
  content: '';
  position: absolute;
  top: -5px;
  left: 50%;
  transform: translateX(-50%) rotate(45deg);
  width: 9px;
  height: 9px;
  background: var(--br-navy-light);
  border-left: 1px solid var(--br-border);
  border-top: 1px solid var(--br-border);
}

.br-nav__item:nth-last-child(-n+2) .br-nav__dropdown::before {
  left: auto;
  right: 20px;
  transform: rotate(45deg);
}

.br-nav__dropdown-inner {
  padding: 1rem 0.5rem 0.8rem;
}

.br-nav__dropdown-heading {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--br-gold);
  padding: 0 0.8rem 0.55rem;
  border-bottom: 1px solid var(--br-border);
  margin-bottom: 0.35rem;
}

.br-nav__dropdown-list {
  list-style: none;
}

.br-nav__dropdown-link {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.46rem 0.8rem;
  font-size: 0.855rem;
  font-weight: 400;
  color: var(--br-text-muted);
  text-decoration: none;
  border-radius: var(--br-radius);
  transition: color 0.18s var(--br-ease),
              background-color 0.18s var(--br-ease),
              padding-left 0.18s var(--br-ease);
}

.br-nav__dropdown-link:hover {
  color: var(--br-white);
  background-color: rgba(200, 150, 62, 0.09);
  padding-left: 1rem;
}

.br-nav__dropdown-link:hover .br-nav__dropdown-dot {
  background-color: var(--br-gold);
  transform: scale(1.4);
}

.br-nav__dropdown-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  flex-shrink: 0;
  transition: background-color 0.18s var(--br-ease),
              transform 0.18s var(--br-ease);
}

/* ── CTA button ──────────────────────────────────────────── */
.br-nav__cta {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.52rem 1.1rem;
  font-size: 0.855rem;
  font-weight: 600;
  /* font-family: var(--font-ui); */
  /* color: var(--br-navy); */
  /* background-color: var(--br-gold); */
  text-decoration: none;
  border-radius: var(--br-radius);
  white-space: nowrap;
  flex-shrink: 0;
  letter-spacing: 0.01em;
  box-shadow: 0 2px 10px rgba(200, 150, 62, 0.35);
  /* transition: background-color 0.2s var(--br-ease),
              box-shadow 0.2s var(--br-ease),
              transform 0.18s var(--br-ease); */
  outline-offset: 3px;

  background: #0F4C5C;
  color: #F7F6F2;
  border: none;
  box-shadow: 0 4px 12px rgba(15, 76, 92, 0.3);
  height: 37px;
}

.br-nav__cta:hover {
  /* background-color: var(--br-gold-hover);
  box-shadow: 0 4px 20px rgba(200, 150, 62, 0.5);
  transform: translateY(-1px); */


   background: #1a6a80;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(15, 76, 92, 0.4);
}

.br-nav__cta:active {
  transform: translateY(0);
}

/* ── Hamburger ───────────────────────────────────────────── */
.br-nav__hamburger {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  width: 38px;
  height: 38px;
  padding: 8px;
  background: none;
  border: none;
  border-radius: var(--br-radius);
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s var(--br-ease);
}

.br-nav__hamburger:hover {
  background-color: rgba(255, 255, 255, 0.07);
}

.br-nav__hamburger span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: var(--br-white);
  border-radius: 2px;
  transform-origin: center;
  transition: transform 0.28s var(--br-ease),
              opacity 0.28s var(--br-ease);
}

.br-nav__hamburger--open span:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}
.br-nav__hamburger--open span:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}
.br-nav__hamburger--open span:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ── Mobile drawer ───────────────────────────────────────── */
.br-nav__mobile {
  position: fixed;
  top: var(--br-nav-h);
  left: 0;
  width: 100%;
  max-height: 0;
  overflow: hidden;
  background-color: var(--br-navy);
  border-top: 1px solid var(--br-border);
  box-shadow: var(--br-shadow-lg);
  transition: max-height 0.4s var(--br-ease);
  z-index: 999;
}

.br-nav__mobile--open {
  max-height: calc(100dvh - var(--br-nav-h));
}

.br-nav__mobile-scroll {
  overflow-y: auto;
  max-height: calc(100dvh - var(--br-nav-h));
  padding-bottom: 1.5rem;
}

/* section row */
.br-nav__mobile-section {
  border-bottom: 1px solid var(--br-border);
}

.br-nav__mobile-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.9rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 500;
  font-family: var(--font-ui);
  color: var(--br-text-primary);
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: color 0.18s var(--br-ease),
              background-color 0.18s var(--br-ease);
}

.br-nav__mobile-toggle:hover {
  color: var(--br-gold);
  background-color: rgba(255, 255, 255, 0.03);
}

/* animated children accordion */
.br-nav__mobile-children {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.32s var(--br-ease);
  background-color: rgba(0, 0, 0, 0.18);
}

.br-nav__mobile-children--open {
  max-height: 400px;
}

.br-nav__mobile-children ul {
  list-style: none;
  padding: 0.3rem 0 0.6rem;
}

.br-nav__mobile-child-link {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.52rem 1.5rem 0.52rem 2rem;
  font-size: 0.875rem;
  color: var(--br-text-muted);
  text-decoration: none;
  transition: color 0.18s var(--br-ease),
              padding-left 0.18s var(--br-ease);
}

.br-nav__mobile-child-link:hover {
  color: var(--br-gold);
  padding-left: 2.25rem;
}

/* mobile CTA */
.br-nav__mobile-cta-wrap {
  padding: 1.25rem 1.5rem 0.5rem;
}

.br-nav__mobile-cta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.85rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: var(--font-ui);
  color: var(--br-navy);
  background-color: var(--br-gold);
  text-decoration: none;
  border-radius: var(--br-radius);
  box-shadow: 0 2px 10px rgba(200, 150, 62, 0.3);
  transition: background-color 0.2s var(--br-ease);
}

.br-nav__mobile-cta:hover {
  background-color: var(--br-gold-hover);
}

/* ── Responsive breakpoints ──────────────────────────────── */
@media (max-width: 1200px) {
  .br-nav__link {
    padding: 0.42rem 0.58rem;
    font-size: 0.84rem;
  }
  .br-nav__cta {
    padding: 0.52rem 0.9rem;
    font-size: 0.82rem;
  }
}

@media (max-width: 960px) {
  .br-nav__links,
  .br-nav__cta {
    display: none;
  }
  .br-nav__hamburger {
    display: flex;
  }
}

@media (max-width: 480px) {
  .br-nav__inner {
    padding: 0 1.25rem;
  }
  .br-nav__logo-name {
    font-size: 1.05rem;
  }
}